/**
 * The fourteen /design screens (P0-9 deliverable 17), in order.
 */

export const SCREEN_SLUGS = [
  'document',
  'script',
  'arc',
  'tonight',
  'run',
  'review',
  'statblock',
  'chronicle',
  'when-calendar',
  'catalog',
  'secrets',
  'inbox',
  'states',
  'reference',
] as const;

export type ScreenSlug = (typeof SCREEN_SLUGS)[number];

export const SCREEN_TITLES: Readonly<Record<ScreenSlug, string>> = {
  document: 'Document page',
  script: 'Script mid-writing',
  arc: 'Arc Story panel',
  tonight: 'Tonight',
  run: 'Run',
  review: 'Review',
  statblock: 'Stat block',
  chronicle: 'Chronicle with timeline strip',
  'when-calendar': 'When input and calendar editor',
  catalog: 'Catalog',
  secrets: 'Secrets',
  inbox: 'Inbox',
  states: 'Empty and error states',
  reference: 'Reference shelf',
};

/** Short labels for the screen navigation. */
export const SCREEN_SHORT: Readonly<Record<ScreenSlug, string>> = {
  document: 'Document',
  script: 'Script',
  arc: 'Arc',
  tonight: 'Tonight',
  run: 'Run',
  review: 'Review',
  statblock: 'Stat block',
  chronicle: 'Chronicle',
  'when-calendar': 'When and calendar',
  catalog: 'Catalog',
  secrets: 'Secrets',
  inbox: 'Inbox',
  states: 'States',
  reference: 'Reference',
};

export function isScreenSlug(value: unknown): value is ScreenSlug {
  return typeof value === 'string' && (SCREEN_SLUGS as readonly string[]).includes(value);
}

/** `01`, `02` … `14`, as the screenshots are numbered. */
export function screenNumber(slug: ScreenSlug): string {
  return String(SCREEN_SLUGS.indexOf(slug) + 1).padStart(2, '0');
}
